/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { measureArea, measureLength } from 'services/utils/measures';

import { addInitHook, override } from './measureUtils';

import { formatArea, formatDistance } from '@leaflet/utils';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';

L.Polyline.include({
  // Mostra as medidas,  de acordo com as opções fornecidas
  showMeasurements: function (
    options = {
      showOnHover: false, // Exibe as medidas ao passar o mouse sobre
      minPixelDistance: 30, // Distância minina para os marcadores serem exibidos
      vertexDistances: {
        enable: false, // Exibe as distâcias entre os vertices
        position: 'centered', // exibe no centro da linha
        tooltip: false, // exibe em tooltip
      },
      showArea: true, // Exibe a medida da area
      showTempPolygon: false, // Exibe um poligono temporário durante o desenho (Ativar apenas se estiver desenhando um poligono)
      showTotalDistance: true, // Exibe a distância total(perimetro)
      showBearing: false, // Exibe a angulação entre os vértices
      showInTooltip: false, // Exibe as inforções no Tooltip, ou Label
      showMarkerPoints: false, // Exibe os pontos em cada vertice
      lang: {
        totalLength: 'Total length',
        totalArea: 'Total area',
        segmentLength: 'Segment length',
      },
    }
  ) {
    if (!this._map || this._measurementLayer) return this;

    this._measurementOptions = {
      showOnHover: false,
      minPixelDistance: 30,
      vertexDistances: {
        enable: false,
        position: 'centered',
        tooltip: false,
      },
      showArea: true,
      showTempPolygon: false,
      showTotalDistance: true,
      showBearing: false,
      showMarkerPoints: false,
      lang: {
        totalLength: 'Total length',
        totalArea: 'Total area',
        segmentLength: 'Segment length',
      },
      ...options,
    };

    this._measurementLayer = L.layerGroup().addTo(this._map);
    this.updateMeasurements();

    this._map.on('zoomend', this.updateMeasurements, this);

    return this;
  },

  // Método para atualizar as options
  setMeasureOptions: function (options) {
    if (!this._map || !this._measurementLayer) return this;

    this._measurementOptions = {
      ...this._measurementOptions,
      ...options,
    };
    this.updateMeasurements();

    return this;
  },

  // Desativa a exibição das medidas
  hideMeasurements: function () {
    if (!this._map) return this;

    this._map.off('zoomend', this.updateMeasurements, this);

    if (!this._measurementLayer) return this;
    this._map.removeLayer(this._measurementLayer);
    this._measurementLayer = null;

    return this;
  },

  // Exibe as medidas ao ser adicionado ao mapa, caso a opção esteja ativa
  onAdd: override(L.Polyline.prototype.onAdd, function (originalReturnValue) {
    this._distanceUnit = 'auto';
    this._areaUnit = 'm';

    if (
      this.options.showMeasurements &&
      !this.options.measurementOptions?.showOnHover
    ) {
      this.showMeasurements(this.options.measurementOptions);
    }

    return originalReturnValue;
  }),

  // Ao remover camada do mapa, remove os listeners e desativa a exibição das medidas
  onRemove: override(
    L.Polyline.prototype.onRemove,
    function (originalReturnValue) {
      this.hideMeasurements();

      return originalReturnValue;
    },
    true
  ),

  // Executando o método para atualizar as medidas quando houver alteração no array de LatLngs
  setLatLngs: override(
    L.Polyline.prototype.setLatLngs,
    function (originalReturnValue) {
      this.updateMeasurements();

      return originalReturnValue;
    }
  ),

  // Executando o método para atualizar as medidas quando houver alteração no array de LatLngs
  spliceLatLngs: override(
    L.Polyline.prototype.spliceLatLngs,
    function (originalReturnValue) {
      this.updateMeasurements();

      return originalReturnValue;
    }
  ),

  // Retorna as unidades de distâncias disponíveis
  getAvailableDistanceUnits: function () {
    return ['auto', 'm', 'km'];
  },

  // Define uma unidade de distância para as conversẽs
  setDistanceUnit: function (unit) {
    let availableUnits = this.getAvailableDistanceUnits();
    this._distanceUnit = availableUnits.includes(unit) ? unit : 'm';
    this.updateMeasurements();
  },

  // Retorna as unidades de área disponíveis
  getAvailableAreaUnits: function () {
    return ['m', 'km', 'ha'];
  },

  // Define uma unidade de área para as conversẽs
  setAreaUnit: function (unit) {
    let availableUnits = this.getAvailableAreaUnits();
    this._areaUnit = availableUnits.includes(unit) ? unit : 'm';
    this.updateMeasurements();
  },

  // Métodods de conversão e formatação das medidas
  formatDistance,
  formatArea,

  // Método que realiza os calculos das medidas
  /**
   * @param {number} latLngs
   * @param {boolean} isPolygon Verifica
   * @param {function} onEachVertex
   * @param {function} onFinish
   * 
   * @returns
   */
  getGeometryMeasurements: function (
    latLngs,
    isPolygon,
    onEachVertex,
    onFinish
  ) {
    const {
      vertexDistances,
      showArea,
      showTotalDistance,
      showBearing,
      showTempPolygon,
    } = this._measurementOptions;

    let ll1,
      ll2,
      p1,
      p2,
      pixelDist,
      dist,
      totalDist = 0,
      bearing,
      area,
      len = latLngs.length,
      lastVertexLatLng;

    const calculateArea = () => {
      if (len > 2 && (showArea || showTempPolygon)) {
        if (showTempPolygon && !isPolygon) {
          // area = ringArea([...latLngs, latLngs[0]]);
          area = measureArea([latLngs.map(Object.values)]);
        } else if (showArea && isPolygon) {
          // area = ringArea(latLngs);          
          area = measureArea([latLngs.map(Object.values)]);
        }
        return area;
      } else {
        return null;
      }
    };

    // Calculando distâncias e angulação
    if (len > 1) {
      for (let i = 1; (isPolygon && i <= len) || i < len; i++) {
        ll1 = latLngs[i - 1];
        ll2 = latLngs[i % len];
        // Calculando a distância
        if (
          showTotalDistance ||
          vertexDistances.enable ||
          this._measurementOptions.showTempPolygon
        ) {                   
          dist = measureLength([
            [ll1.lat, ll1.lng],
            [ll2.lat, ll2.lng]
          ]);
          
          totalDist += dist;          
        }
        // Calculando a angulação
        if (showBearing) {
          bearing = turf
            .bearing([ll1.lng, ll1.lat], [ll2.lng, ll2.lat], {
              final: true,
            })
            .toFixed(2);
        }
        // Calculando a distância em pixeis
        p1 = this._map.latLngToLayerPoint(ll1);
        p2 = this._map.latLngToLayerPoint(ll2);
        pixelDist = p1.distanceTo(p2);

        let last = i === len - 1;
        if (last) lastVertexLatLng = ll2;
        // Chamando callback passando as medidas calculadas para cada vértice no loop
        if (onEachVertex)
          onEachVertex(
            ll1,
            ll2,
            p1,
            p2,
            dist,
            totalDist,
            bearing,
            pixelDist,
            last,
            calculateArea()
          );
      }
    }

    // Calculando area
    if (len > 2 && (showArea || showTempPolygon) && onFinish) {
      onFinish({
        area: calculateArea(),
        perimeter: totalDist,
        lastVertexLatLng,
      });
    }
  },

  /**
   * Método que realiza a atualização das medidas na interface
   * @param {*} event Dados retornados por eventos. Ex: latlng atual do ponteiro do mouse
   */
  updateMeasurements: function (event = null) {
    // Captura a posição atual do mouse, para realizar as medições baseadas na posição do cursor
    let curLatLng;
    if (event?.type === 'mousemove') {
      curLatLng = event.latlng;
    }

    // Verifica se a medição está realmente ativa
    if (!this._measurementLayer) return this;

    let latLngs = this.getLatLngs(),
      isPolygon = this instanceof L.Polygon,
      areaFormatter = L.bind(this.formatArea, this),
      distanceFormatter = L.bind(this.formatDistance, this),
      tempPolygon;

    // Em alguns casos a geometria é armazenada no primeiro elemento do array de latlngs
    if (latLngs?.length > 0 && L.Util.isArray(latLngs[0])) {
      latLngs = latLngs[0];
    }

    // Adicionando a posição atual do mouse ao array de coordenadas
    latLngs = curLatLng ? [...latLngs, curLatLng] : latLngs;

    this._measurementLayer.clearLayers();

    /**
     * Função que aciona a mostragem de informações passadas,
     * dadas as coordenadas onde elas devem estar
     */
    /**
     * showMeaserueData
     * 
     * @param {*} displayTooltip
     * @param {number} LatLng
     * @param {*} contentData
     * @param {*} rotationInDegrees
     * @param {*} lastVertex
     */
    const showMeasureData = ({
      displayTooltip,
      LatLng,
      contentData,
      rotationInDegrees,
      lastVertex,
    }) => {
      // default de variaveis não obrigatórias
      displayTooltip =
        displayTooltip ||
        (typeof displayTooltip === 'undefined' &&
          this._measurementOptions.vertexDistances.tooltip);

      // Função que retorna a medida de distância entre os vértices inline
      const returnInlineData = () => {
        let contentInfoStr = contentData.reduce(
          (finalString, info) => `${finalString} ${info} <br/>`,
          ''
        );
        L.marker
          .measurement(
            LatLng,
            contentInfoStr,
            '',
            rotationInDegrees,
            this._measurementOptions,
            displayTooltip
          )
          .addTo(this._measurementLayer);
      };

      const returnTooltipData = () => {
        L.marker
          .tooltip(LatLng, contentData, this._measurementOptions)
          .addTo(this._measurementLayer);
      };

      if (
        lastVertex ||
        this._measurementOptions.vertexDistances.position !== 'centered'
      ) {
        // Exibe dados em forma de tooltip, que por padrão é no vértice, nesse momento
        returnTooltipData();
      } else {
        // Exibe dados no centro, que por padrão é no centro
        returnInlineData();
      }
    };

    // Função que será executada ao percorrer cada vertice
    const onEachVertex = (
      ll1,
      ll2,
      p1,
      p2,
      dist,
      totalDist,
      bearing,
      pixelDist,
      last,
      area
    ) => {
      const writingPolygon = Boolean(
          this._measurementOptions.showTempPolygon && !isPolygon
        ),
        isMouseMarker = Boolean(curLatLng && last);

      if (
        (pixelDist >= this._measurementOptions.minPixelDistance &&
          this._measurementOptions.vertexDistances.enable) ||
        (last && curLatLng)
      ) {
        let contentInfo = [],
          difDistance,
          positionInLine = this._map.layerPointToLatLng([
            (p1.x + p2.x) / 2,
            (p1.y + p2.y) / 2,
          ]),
          rotation = this._getRotation(ll1, ll2);

        /** *** ÁREA/POLÍGONO *** **/
        if (this._measurementOptions.showTempPolygon) {
          // Caso seja o ponto onde o cursor está agora mostra algumas infomrações
          if (isMouseMarker) {
            if (area)
              contentInfo.push(areaFormatter(`Área: ${area}`, this._areaUnit));
            contentInfo.push(
              distanceFormatter(`Per.: ${totalDist}`, this._distanceUnit)
            );
          } else {
            if (isPolygon && this._measurementOptions.showTotalDistance && dist)
              contentInfo.push(distanceFormatter(dist, this._distanceUnit));
          }
          /** *** DISTÂNCIA/LINHA *** **/
        } else {
          if (isMouseMarker) {
            difDistance = `(+${distanceFormatter(dist, this._distanceUnit)})`;
            if (totalDist)
              contentInfo.push(
                distanceFormatter(totalDist, this._distanceUnit)
              );
            if (difDistance) contentInfo.push(difDistance);
            if (bearing) contentInfo.push(`${bearing} °`);
          } else if (
            this._measurementOptions.vertexDistances.position === 'vertex'
          ) {
            // ! Aqui é um "hack", pois a ferramenta de medir distância é diferente da de criar linha nos comportamentos de exibição de medidas. A diferença entre eles é que um mostra no vértice e outro no centro da linha, então estou usando isso para diferenciá-los
            if (totalDist)
              contentInfo.push(
                distanceFormatter(totalDist, this._distanceUnit)
              );
            if (bearing) contentInfo.push(`${bearing} °`);
          } else {
            contentInfo.push(distanceFormatter(dist, this._distanceUnit));
            if (bearing) contentInfo.push(`${bearing} °`);
          }
        }

        if ((writingPolygon && isMouseMarker) || !writingPolygon) {
          let latlng2 = ll2;
          if (isMouseMarker && writingPolygon) {
            latlng2 = this._map.layerPointToLatLng([p2.x, p2.y - 10]);
          }
          showMeasureData({
            LatLng:
              isPolygon ||
              (this._measurementOptions.vertexDistances.position ===
                'centered' &&
                !isMouseMarker)
                ? positionInLine
                : latlng2,
            contentData: contentInfo,
            rotationInDegrees: rotation,
            lastVertex:
              isMouseMarker || (!writingPolygon && !isPolygon && isMouseMarker),
          });
        }
      }

      if (this._measurementOptions.showMarkerPoints) {
        L.circleMarker(ll1, {
          radius: 4,
          fillOpacity: 1,
          snapIgnore: true,
        }).addTo(this._measurementLayer);

        if (last) {
          L.circleMarker(ll2, {
            radius: 4,
            fillOpacity: 1,
            snapIgnore: true,
          }).addTo(this._measurementLayer);
        }
      }
    };

    /**
     * Função que será executada ao finalizar as medições
     * Quando as medições finalizam ainda na movimentação
     * e atualização da movimentação do mouse
     */
    const onFinish = ({ area, perimeter, lastVertexLatLng }) => {
      // Exibe a distância total de uma polyline num tooltip na ponta da linha
      if (
        this._measurementOptions.showTotalDistance &&
        this._measurementOptions.vertexDistances.position === 'centered' &&
        !isPolygon &&
        !curLatLng
      ) {
        L.marker
          .tooltip(
            lastVertexLatLng,
            distanceFormatter(perimeter, this._distanceUnit),
            this._measurementOptions
          )
          .addTo(this._measurementLayer);
      }

      // Exibe um poligono temporário na tela, durante o desenho
      if (
        !isPolygon &&
        this._measurementOptions.showTempPolygon &&
        latLngs.length > 2
      ) {
        tempPolygon = L.polygon([...latLngs, latLngs[0]], {
          weight: 0,
          snapIgnore: true,
        }).addTo(this._measurementLayer);
      }

      /**
       * Exibe a area e o perimetro de um poligono, em caso de o poligono estar sendo
       * criando (desenhado), será exibida a area do poligono temporário
       */
      if (isPolygon && latLngs.length > 2) {
        let contentInfo = [];

        // Adicionando medida de área
        if (area && this._measurementOptions.showArea)
          contentInfo.push(areaFormatter(`Área: ${area}`, this._areaUnit));
        // Adicionando medida de perímetro
        if (perimeter && this._measurementOptions.showTotalDistance)
          contentInfo.push(
            distanceFormatter(`Per.: ${perimeter}`, this._distanceUnit)
          );

        showMeasureData({
          displayTooltip: false,
          LatLng: isPolygon
            ? this.getBounds().getCenter()
            : tempPolygon.getBounds().getCenter(),
          contentData: contentInfo,
          rotation: 0,
          lastVertex: !isPolygon,
        });
      }
    };

    if (latLngs.length > 1) {
      this.getGeometryMeasurements(latLngs, isPolygon, onEachVertex, onFinish);
    }

    return this;
  },

  _getRotation: function (ll1, ll2) {
    var p1 = this._map.project(ll1),
      p2 = this._map.project(ll2);

    return Math.atan((p2.y - p1.y) / (p2.x - p1.x));
  },
});

L.Polyline.addInitHook(function () {
  addInitHook.call(this);
});
